var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import HardDriveIconSvg from './hard-drive.icon.svg';
export const HardDriveIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: HardDriveIconSvg });
};
_react_refresh_temp_1 = HardDriveIcon;
$RefreshReg$(_react_refresh_temp_1, "HardDriveIcon");
